var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-1.125 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M17.508,6.715h-.667v3.711L19.25,11.57l.286-.6L17.508,10Z",
    transform: "translate(-11.059 -3.934)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M6.125,1.125a5,5,0,1,0,5,5A5,5,0,0,0,6.125,1.125Zm0,9.333a4.333,4.333,0,1,1,4.333-4.333A4.333,4.333,0,0,1,6.125,10.458Z",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ClockDark.0a63703af28db18dd98b5a94f828a8d4.svg";